import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { failed: boolean };

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('PlantGrow UI error', {
      message: error.message,
      stack: error.stack,
      componentStack: info.componentStack,
    });
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <main className="fatal-error-page" role="alert">
        <section>
          <span>PlantGrow</span>
          <h1>Something did not load properly.</h1>
          <p>Your account and saved plants have not been changed. Reload the page to try again.</p>
          <button type="button" onClick={() => window.location.reload()}>Reload PlantGrow</button>
          <a href="/">Return home</a>
        </section>
      </main>
    );
  }
}
